 // Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { connect } from "react-redux";
import LoadingOverlay from "react-loading-overlay";
import { bindActionCreators } from "redux";
import { elementContains, Spinner, SpinnerSize } from "office-ui-fabric-react";
import IUserModelActions, * as userModelActions from "../../../../redux/actions/modalActions";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import { IProject, IAuthenticationState, IApplicationState, IConnection, IAzureFields } from "../../../../models/applicationState";
import HeaderComponent from "../header/header";
import size from "lodash/size";
import IFilesUploadingAction, * as filesUploadingAction from "../../../../redux/actions/filesUploadingAction";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import MyModels from "../myModels/myModels";
import axios from "axios";
import { accessToken, getOrderMgtdocUrlsEndpoint,headers,orderMgt_UpdateStatus} from "../../../../common/api-config";

import base64 from "base-64";
import { toast } from "react-toastify";
import Select from "react-select";
import filterIcon from "../../../../assets/images/Filter-icon.svg";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import moment from "moment";

import {
  Customizer,
  Dialog,
  DialogFooter,
  DialogType,
  ICustomizations,
  ITheme,
  PrimaryButton,
} from "@fluentui/react";

import { getDarkTheme, getPrimaryBlueTheme } from "../../../../common/themes";
// import "../invoiceManagement/invoicemanagement.scss";
// import Modal from "react-bootstrap/esm/Modal";
// import Button from "react-bootstrap/esm/Button";

export interface IOrderManagementProps extends RouteComponentProps, React.Props<OrderManagement> {
  userModelActions: IUserModelActions;
  loggedInUser: IAuthenticationState;
  userOperationsActions: IUserOperationsActions;
  filesUploadingAction: IFilesUploadingAction;
  actions: IProjectActions;
  project: IProject;
  recentProjects: IProject[];
  path: object;
  projectActions: IProjectActions;
  userModels: any;
}

export interface IOrderManagementState {

  userId: string;
  connection: IConnection;
  om_myModels: any;
  om_loadModal: boolean;
  showDate: boolean;
  om_allData: any;
  om_loaderText: string;
  loadingProjects: boolean;
  om_loadingProjects: boolean;
  selectedFilter: any;
  invoiceWithOrwithoutPO: String;
  selectedRecords: any;
  fromDate: any;
  toDate: any;
  om_loadProcess: boolean;
  appliedFilters: any;
  companyFilter: boolean;
  vendorFilter: boolean;
  irFilter: boolean;
  searchText: null;
  om_headers: any;
  AI_models: any;
  show: boolean;
  setShow: boolean;
  selectedRow: any;
  currentPage:number;
  displayCountPerPage:number;
  currentLength:number;
  om_Country:any;
  selectedcountry:any;
  statusList:any;
  
  selectedStatus:any;
  om_selectedStatus:any;
  om_selectedCountry:any;
  
  //new fields start
  om_statusList:any;
  om_spl_statusList:any;
  om_selectedTFStatus:any;  
  om_displayAdvancedPopup:boolean;
  om_advancedFilters:any;  
  om_af_PO:any;
  om_af_mail_relavance:any;
  om_af_Ship:any;
  om_af_Country:any;
  om_af_Status:any;
  om_af_FromDate:any;
  om_af_ToDate:any;
  om_af_Plant:any;
  om_af_MultipleOrdersFlag:any;
  om_af_RequestDetailsID:any;
  om_displayCountrydd:boolean;
  om_displayStatusdd:boolean;
  om_selectedTFCountry:any;
 // om_selectedStatus:any;
  //new fields end
  
  om_searchText: any;
  om_updatestatusSelVal:any;
  om_selectedRecords: any;
  SortDate:any;
  selectAllReqId:any;
  hidePopUp:any;
  hideSuccPopUp:any;
  checkedId:any;
}

function mapDispatchToProps(dispatch) {
  return {
    userModelActions: bindActionCreators(userModelActions, dispatch),
    userOperationsActions: bindActionCreators(userOperationsActions, dispatch),
    filesUploadingAction: bindActionCreators(filesUploadingAction, dispatch),
    actions: bindActionCreators(projectActions, dispatch),
  };
}

function mapStateToProps(state: IApplicationState) {
  return {
    loggedInUser: state.loggedInUser,
  };
}
@connect(mapStateToProps, mapDispatchToProps)

export default class OrderManagement

  extends React.Component<IOrderManagementProps, IOrderManagementState> {


  greenCheck: boolean;
  redCheck: boolean;
  yellowCheck: boolean;

  public state: IOrderManagementState = {
    userId: null,
    connection: { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} },
    om_myModels: [],
    om_loadModal: false,
    showDate: false,
    om_loadProcess: false,
    om_allData: [],
    om_loaderText: "Loading files to preview...",
    loadingProjects: false,
    om_loadingProjects: false,
    selectedFilter: '',
    invoiceWithOrwithoutPO: '',
    selectedRecords: [],
    fromDate: '',
    toDate: '',
    appliedFilters: [],
    companyFilter: false,
    vendorFilter: false,
    irFilter: false,
    searchText: null,
    om_headers: [],
    AI_models: [],
    show: false,
    setShow: false,
    selectedRow: {},
    currentPage: 1,
    displayCountPerPage:10,
    currentLength:20,
    om_Country:[],
    selectedcountry:[],
	statusList:[],
	selectedStatus:[],
  
  om_selectedStatus:[],
  om_selectedCountry:[],
  
  om_selectedTFStatus:[],
  om_selectedTFCountry:[],
  om_statusList:[],
  
  //om_selectedTFStatus:[],
  om_displayAdvancedPopup:false,
  om_advancedFilters:[],
  om_af_PO:'',
  om_af_mail_relavance:'',
  om_af_Ship:'',
  om_af_Country:'',
  om_af_Status:'',
  om_af_FromDate:'',
  om_af_ToDate:'',
  om_af_Plant:'', 
  om_af_MultipleOrdersFlag:'',
  om_af_RequestDetailsID:'', 
  om_displayCountrydd:false,
  om_displayStatusdd:false ,
  
  om_searchText: null, 
  om_updatestatusSelVal:[],
  om_selectedRecords: [],
  om_spl_statusList:[],
  SortDate:'ASC',
  selectAllReqId:'',
  hidePopUp:true,
  hideSuccPopUp:true,
  checkedId:"",
  };
  records = [];
  orderRef : any;
  nodeDropdown:any;
  nodeCountryDropdown:any;
  green_selected: boolean;
  yellow_selected: boolean;
  red_selected: boolean;
  allDettsils: any
  handleClose = () => {
    this.setState({ show: false })
  };
  constructor(props) {
    super(props);
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate()
    let currentDate = year + "-" + month + "-" + day
    this.setState({ fromDate: currentDate })
    this.outClick = this.outClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }
    outClick(){
      if (!this.state.om_displayAdvancedPopup) {
        // attach/remove event handler
        document.addEventListener('click', this.handleOutsideClick, false);
      } else {
        document.removeEventListener('click', this.handleOutsideClick, false);
      }

      this.setState(prevState => ({
        om_displayAdvancedPopup: !prevState.om_displayAdvancedPopup,
      }));
  }

  handleOutsideClick(e) {
    if(this.orderRef){
      if (this.orderRef.contains(e.target)) {
        return;
      }
     if(this.nodeDropdown){
        if(this.nodeDropdown.props){
          if(this.nodeDropdown.props.value){
            if(this.nodeDropdown.props.value.value == e.target.textContent || e.target.textContent == "No options"){
              return;
            }
          }
        }
      }
      if(this.nodeCountryDropdown){
        if(this.nodeCountryDropdown.props){
          if(this.nodeCountryDropdown.props.value){
            if(this.nodeCountryDropdown.props.value.value == e.target.textContent || e.target.textContent == "No options"){
              return;
            }
          }
        }
      }
    }
    this.outClick();
  }
  
  handleClickNew_OM(event,id){
    this.setState({
      selectAllReqId:id,
     // hideSuccPopUp:true
    })
    let p = [...this.state.om_myModels]
    if (event.target.checked) {
      Object.keys(p).map(key=>{
        if(p[key]["RequestDetailsID"] == id){
          p[key]["isChecked"] = true
        }
      })
      this.setState({ om_selectedRecords: this.state.om_myModels })
    }
    else{
      Object.keys(p).map(key=>{
        if(p[key]["RequestDetailsID"] == id){
          p[key]["isChecked"] = false
        }
      })
    this.setState({ om_selectedRecords: [] })
    }
    
    this.setState({
      om_myModels:p
    })
  }


  handleClick(event) {
    if (event.target.nodeName === 'INPUT' && event.target.parentElement.nodeName === 'TH') {
      let tbody = document.getElementsByTagName('tbody')[0]
      let checks = tbody.getElementsByTagName('input')
      if (event.target.checked) {
        for (let i = 0; i < checks.length; i++) {
          checks[i]['checked'] = true;
        }
        this.setState({ om_selectedRecords: this.state.om_myModels })
      }
      else {
        for (let i = 0; i < checks.length; i++) {
          checks[i]['checked'] = false;
        }
        this.setState({ om_selectedRecords: [] })

      }
    }

  }

  handlePageClick(event) {
    this.setState({
      currentPage: Number(event.target.id)
    });
  }

  handleNextClick(e)
  {
    let currentPage = this.state.currentPage;
    const lastpage = Math.ceil(this.state.om_myModels.length / this.state.displayCountPerPage);
    if(currentPage===lastpage)
    {
       
    }
    else
    {
    currentPage =  currentPage+1;
    }
    
    this.setState({
      currentPage: currentPage
    });
  }
  handlePreviousClick(e)
  {
    let currentPage = this.state.currentPage;
    if(currentPage===1)
    {
       
    }
    else
    {
    currentPage = currentPage-1;
    }
    
    this.setState({
      currentPage: currentPage
    });
  }
  handleSingleCheck(model) {
	  /*
    if (this.records.length > 0) {
      let present = false;
      for (var i = 0; i < this.records.length; i++) {
        if (this.records[i].Filename == model.Filename) {
          present = true;
          this.records.splice(i, 1);
          break;
        }
      }

      if (!present) {
        this.records.push(model)
      }
    } else {
      this.records.push(model)
    }

    this.setState({ selectedRecords: this.records })
*/
  }
  
  validateMultiple_OM(model,e,index){
    //debugger;
    if(e.target.checked){
      let p = [...this.state.om_myModels]
      p[index]["isChecked"] = true
      this.setState({
        om_myModels : p
      },()=>{
        let found = false , id = ""
      Object.keys(this.state.om_myModels).map(key=>{
        if(this.state.om_myModels[key]["RequestDetailsID"] == model["RequestDetailsID"]){
          if(this.state.om_myModels[key]["isChecked"]!=true){
              found = true
              id = this.state.om_myModels[key]["RequestDetailsID"]
            }
        }
      })
      if(found){
        this.setState({
          hidePopUp:false,
          checkedId:id
        })
        this.handleSingleCheck_OM_New(model,true,index)
      }
      else{
        this.handleSingleCheck_OM_New(model,true,index)
      }
      })
    }
    else{
      let p = [...this.state.om_myModels];
      p[index]["isChecked"] = false;
      this.setState({
        om_myModels : p
      })
      this.handleSingleCheck_OM_New(model,false,index)
    }
    
    //uncheck the selected status
    //this.setState({ updatestatusSelVal: [] });
    
    
     
  }
  
  handleSingleCheck_OM_New(model,status,index) {
   
    let records = this.state.om_selectedRecords;
    // this.setState({ selectedRecords: this.records })
     //debugger;
     if(status)
     {     
       
       //
       let present = false;
       for (var i = 0; i < records.length; i++) {
         if (records[i].RowKey == model.RowKey) {
           present = true;          
           break;
         }
       }
       if (!present) {
         records.push(model)
       }      
       //
       
     }
     else
     {
       //
       let present = false;
       for (let i = 0; i < records.length; i++) {
         if (records[i].RowKey == model.RowKey) {  
           present = true; 
           break;
                 }
       }      
       if (present) {
         records.splice(i, 1);
       }
       //     
       
     }
     /*
     if (this.records.length > 0) {
       let present = false;
       for (var i = 0; i < this.records.length; i++) {
         if (this.records[i].Filename == model.Filename) {
           present = true;
           this.records.splice(i, 1);
           break;
         }
       }
 
       if (!present) {
         this.records.push(model)
       }
     } else {
       this.records.push(model)
     }
     */
     //this.setState({ selectedRecords: this.records });
     this.setState({ om_selectedRecords: records });
 
 
   }
  
 om_handleSingleCheck(model,e) {
    let records = this.state.om_selectedRecords;
    // this.setState({ selectedRecords: this.records })
     //debugger;
     if(e.target.checked)
     {     
       
       //
       let present = false;
       for (var i = 0; i < this.records.length; i++) {
         if (this.records[i].RowKey == model.RowKey) {
           present = true;          
           break;
         }
       }
       if (!present) {
         this.records.push(model)
       }      
       //
       
     }
     else
     {
       //
       let present = false;
       for (var i = 0; i < this.records.length; i++) {
         if (this.records[i].RowKey == model.RowKey) {  
           present = true; 
           break;
                 }
       }      
       if (present) {
         this.records.splice(i, 1);
       }
       //     
       
     }
     /*
     if (this.records.length > 0) {
       let present = false;
       for (var i = 0; i < this.records.length; i++) {
         if (this.records[i].Filename == model.Filename) {
           present = true;
           this.records.splice(i, 1);
           break;
         }
       }
 
       if (!present) {
         this.records.push(model)
       }
     } else {
       this.records.push(model)
     }
     */
     this.setState({ om_selectedRecords: this.records });
 
   }

  public async componentDidMount() {
    const user = this.props.loggedInUser;
    const userId = user.user.oid;
    await this.setState({ om_loadModal: true, userId });
    localStorage.removeItem("lastVisttedtestAssetId");
    localStorage.removeItem("filesLength");
    localStorage.removeItem("testFilesLengthFromTest");
    localStorage.removeItem("filesLengthFromModel");
    this.setState({ om_loadModal: true });
    
	
	this.getInitialData();
 
  }
  
  public async getInitialData()
  {
	  
    let isBackClick = localStorage.getItem("omDocMgtBack");


    let modelData
    if(isBackClick=== "Y")
    {
      let selectedFilters = JSON.parse(localStorage.getItem("selectedomDocMgtFilters"));
      let startDate = selectedFilters.om_af_FromDate?selectedFilters.om_af_FromDate:"";
      let endDate = selectedFilters.om_af_ToDate? selectedFilters.om_af_ToDate:"";
     if(startDate!="")
      {
        /*
        modelData = await this.props.userOperationsActions.orderMangementByDate
        (moment(startDate).startOf('day').format("MM/DD/YYYY[T]HH:mm:ss"),
        moment(endDate).endOf('day').format("MM/DD/YYYY[T]HH:mm:ss"));
        */
        
        modelData = await this.props.userOperationsActions.orderMangementByDate
        (moment(startDate).startOf('day').format("YYYY-MM-DD[T]HH:mm:ss"),
        moment(endDate).endOf('day').format("YYYY-MM-DD[T]HH:mm:ss"));
      }
      else{
        modelData = await this.props.userOperationsActions.orderMangement();
      }
    }
    else{
      modelData = await this.props.userOperationsActions.orderMangement();
    }
	 
  localStorage.setItem("omDocMgtBack", "N");
    let firstRow = modelData[0];
    this.allDettsils = modelData;
    let keys = [];
    let finalKeys = [];
    if (this.allDettsils.length) {
      keys = Object.keys(firstRow);
      keys.forEach((element, i) => {
        if (element == 'Tagsinfo' || element == 'url') {
          keys.splice(i, 1)
        }
      })
    }

   // console.log(keys);
    let Aimodels = [];
    this.allDettsils.forEach(element => {
      if (Aimodels.length > 0) {
        let present = false;
        Aimodels.forEach(data => {
          if (data.value == element.PartitionKey) {
            present = true;
          }
        })
        if (!present) {
          Aimodels.push({ value: element.PartitionKey, label: element.PartitionKey })
        }
      } else {
        Aimodels.push({ value: element.PartitionKey, label: element.PartitionKey })
      }
    });
    // contry
    let country=[];
    
    /*
    this.allDettsils.forEach(element => {
      if (country.length > 0) {
        let present = false;
        country.forEach(data => {
          if (data.value == element.Country) {
            present = true;
          }
        })
        if (!present) {
          country.push({ value: element.Country, label: element.Country })
        }
      } else {
        country.push({ value: element.Country, label: element.Country })
      }
    });
    */
    
    country.push({ value: "ca", label: "ca" });
    country.push({ value: "us", label: "us" });
    country.push({ value: "All", label: "All" });
   // debugger;
	
	let statusList=[];
  
	let spl_statusList=[];
	 
  
  
	this.allDettsils.forEach(element => {
		if (statusList.length > 0) {
		  let present = false;
		  statusList.forEach(data => {
			if (data.value == element.Status) {
			  present = true;
			}
		  });
		  if (!present) {
			statusList.push({ value: element.Status, label: element.Status });
      spl_statusList.push({ value: element.Status, label: element.Status });
		  }
		} else {
			statusList.push({ value: element.Status, label: element.Status });
      spl_statusList.push({ value: element.Status, label: element.Status });
		}
	  });
	
    //debugger;
    if (statusList.length > 0) {
      
      statusList.push({ value: "All", label: "All" })
    }
    
    //
    
    if(isBackClick=== "Y")
    {
      let selectedFilters = JSON.parse(localStorage.getItem("selectedomDocMgtFilters"));
      
      
      this.setState({
        om_searchText:selectedFilters.om_searchText,
        om_af_Status:selectedFilters.om_af_Status,
        om_af_Country:selectedFilters.om_af_Country,
        om_af_FromDate:selectedFilters.om_af_FromDate,        
        om_af_ToDate:selectedFilters.om_af_ToDate,
        om_af_mail_relavance:selectedFilters.om_af_mail_relavance,        
        om_af_PO:selectedFilters.om_af_PO,
        om_af_Plant:selectedFilters.om_af_Plant,
        om_af_MultipleOrdersFlag:selectedFilters.om_af_MultipleOrdersFlag,        
        om_af_RequestDetailsID:selectedFilters.om_af_RequestDetailsID,
        om_displayCountrydd:selectedFilters.om_displayCountrydd,
        om_displayStatusdd:selectedFilters.om_displayStatusdd,
        om_selectedTFStatus:selectedFilters.om_selectedTFStatus,
        om_selectedTFCountry:selectedFilters.om_selectedTFCountry 
        
              });  
              
              
              if(selectedFilters.af_Country!="")
              {
                this.setState({ om_selectedCountry: [{ value: selectedFilters.om_af_Country, 
                                                    label: selectedFilters.om_af_Country }] });
              }
              else
              {
                this.setState({ om_selectedCountry: [] });
              }
              
              
              if(selectedFilters.om_af_Status!="")
              {
                this.setState({ om_selectedStatus: [{ value: selectedFilters.om_af_Status, 
                                                    label: selectedFilters.om_af_Status }] });
              }
              else
              {
                
                this.setState({ om_selectedStatus: [] });
              }
              
              
              // let startDate = selectedFilters.af_FromDate?selectedFilters.om_af_FromDate:"";
                            
              // let endDate = selectedFilters.af_ToDate? selectedFilters.om_af_ToDate:"";
              let startDate = selectedFilters.om_af_FromDate?selectedFilters.om_af_FromDate:"";
                            
              let endDate = selectedFilters.om_af_ToDate? selectedFilters.om_af_ToDate:"";
               
            this.om_getOrderMgtDatabydateCountryStatus_af(startDate,endDate,          
             
              selectedFilters.om_af_Country?selectedFilters.om_af_Country:"",
              selectedFilters.om_af_Status?selectedFilters.om_af_Status:"",
                 
              selectedFilters.om_af_mail_relavance?selectedFilters.om_af_mail_relavance:"",
              selectedFilters.om_af_PO?selectedFilters.om_af_PO:"",   
              
              selectedFilters.om_af_Country?selectedFilters.om_af_Plant:"",
              selectedFilters.om_af_MultipleOrdersFlag?selectedFilters.om_af_MultipleOrdersFlag:"",   
              selectedFilters.om_af_RequestDetailsID?selectedFilters.om_af_RequestDetailsID:"",
              selectedFilters.om_searchText?selectedFilters.om_searchText:"",
              
              selectedFilters.om_selectedTFStatus,
              selectedFilters.om_selectedTFCountry,
              modelData
              
              
              );
              
              
      //
    
      //
    }
    
    //
    
    this.setState({ om_loadModal: false, om_myModels: modelData, om_allData: modelData, om_headers: keys,  om_Country: country,om_statusList:statusList,om_spl_statusList:spl_statusList},()=>{
      let result = this.state.om_myModels;
      result.sort((a, b) => {
        if (isNaN(new Date(b["Email_Date"]).getTime())&&isNaN(new Date(a["Email_Date"]).getTime())) { 
          return (b["Email_Date"]!=""?(moment(b["Email_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0)
          - (a["Email_Date"]!=""?(moment(a["Email_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0);
        }
        else{
          return (b["Email_Date"]!=""?(new Date(b["Email_Date"]).getTime()):0)
          - (a["Email_Date"]!=""?(new Date(a["Email_Date"]).getTime()):0);
        }
       });
     this.setState({
      om_myModels:result
     })
    });

  }
  
  
  public om_getOrderMgtDatabydateCountryStatus_af =async (fromDate:string, toDate:string,     
    scountry:any, status:any,    mail_relavance:any,po:any,plant:any, MultipleOrdersFlag:any,
    
    RequestDetailsID:any,  searchText:string,selectedTFStatus:any, selectedTFcountry:any,
    modelData:any
    )=>
  {
   
    await this.setState({ om_loadingProjects: true});
  //  this.setState({ loadModal: true });
   // toast.success("Fetching the Records", { position: toast.POSITION.TOP_CENTER });
  //  let  modelData;
    // if(fromDate!="")
    // {
    //  // modelData = await this.props.userOperationsActions.documentMangementByDate(fromDate,toDate);
   
    //   modelData = await this.props.userOperationsActions.orderMangementByDate
    //   (moment(fromDate).startOf('day').format("MM/DD/YYYY[T]HH:mm:ss"),
    //   moment(toDate).endOf('day').format("MM/DD/YYYY[T]HH:mm:ss"));
    
    // }
    // else
    // {
    //   modelData = await this.props.userOperationsActions.orderMangement();
    // }

    modelData.sort((a, b) => {
      if (isNaN(new Date(b["Email_Date"]).getTime())&&isNaN(new Date(a["Email_Date"]).getTime())) { 
        return (b["Email_Date"]!=""?(moment(b["Email_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0)
        - (a["Email_Date"]!=""?(moment(a["Email_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0);
      }
      else{
        return (b["Email_Date"]!=""?(new Date(b["Email_Date"]).getTime()):0)
        - (a["Email_Date"]!=""?(new Date(a["Email_Date"]).getTime()):0);
      }
     });
    this.setState({
      SortDate: "ASC"
    })
   this.setState({ om_allData: modelData});
    let firstRow = modelData[0];
    this.allDettsils = modelData;
    let keys = [];
    let finalKeys = [];
   // toast.success("Number of Records Found:"+this.allDettsils.length, { position: toast.POSITION.TOP_CENTER });
    if (this.allDettsils.length) {
      keys = Object.keys(firstRow);
      keys.forEach((element, i) => {
        if (element == 'Tagsinfo' || element == 'url') {
          keys.splice(i, 1)
        }
      })
    }

    let Aimodels = [];
  
    
    // contry
    let country=[];
    
    //
      
  country.push({ value: "ca", label: "ca" });
  country.push({ value: "us", label: "us" });
  country.push({ value: "All", label: "All" });

    let statusList=[];
    //
    this.allDettsils.forEach(element => {
      if (statusList.length > 0) {
        let present = false;
        statusList.forEach(data => {
        if (data.value == element.Status) {
          present = true;
        }
        });
        if(element.Status!="")
        {
        if (!present) {
        statusList.push({ value: element.Status, label: element.Status })
        }
      } else {
         if(element.Status.trim()!="")
        {
        //
        statusList.push({ value: element.Status, label: element.Status });
        }
      }
    }
      });
    //
     
    if (statusList.length > 0) {
      statusList.push({ value: "All", label: "All" })
    }
   //
    if (scountry!= "") {
      if (scountry === "All") {
        modelData = modelData;
      }
      else{
      
      modelData = modelData.filter(element => element.Country == scountry);
      }
    
    } 
    
    if (status != "") {
      
      if (status === "All") {
        modelData = modelData;
      }
      else
      {
        modelData = modelData.filter(element => element.Status == status);  
      }
      
     // modelData = modelData.filter(element => element.Status == status);    
    } 
    
    
    
    
    if (mail_relavance != "") {
      modelData = modelData.filter(element => element.Mail_Relevance == mail_relavance);    
    } 
    
    if (po != "") {
      modelData = modelData.filter(element => element.PO == po);    
    } 
    
 
    if (plant != "") {
      modelData = modelData.filter(element => element.Plant == plant);    
    } 
    
    if (MultipleOrdersFlag != "") {
      modelData = modelData.filter(element => element.Plant == MultipleOrdersFlag);    
    } 
    
    if (RequestDetailsID != "") {
      modelData = modelData.filter(element => element.RequestDetailsID == RequestDetailsID);    
    } 
      
    
    
    if (searchText != "") {
     
      modelData = modelData.filter(element => element.RequestDetailsID.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||
    
    element.Mail_Relevance.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||   
    element.MultipleOrdersFlag.trim().toUpperCase().startsWith(searchText.toUpperCase()) ||    
    element.Plant.trim().toUpperCase().startsWith(searchText.toUpperCase()) );
    }
    
    
    //table filters start
    //debugger;
if(selectedTFcountry!=null)
{
    let coun = selectedTFcountry;
    let counval = coun.value?coun.value:"";
     
    if(counval !== "" && counval !== "All"){     
    modelData = modelData.filter(element => ( element.Country == counval));    
}
}
if(selectedTFStatus!=null)
{
let couns = selectedTFStatus;

    let counsval = couns.value?couns.value:"";
     
    if(counsval !== "" && counsval !== "All"){     
    modelData = modelData.filter(element => ( element.Status == counsval));    
}
}







    //table filters end
    
    
    debugger;
    await this.setState({ om_loadingProjects: false});
    //
    await this.setState({ loadingProjects: false});
    this.setState({ om_myModels: modelData,  om_Country: country,om_statusList:statusList});
    this.setState({ fromDate: fromDate, toDate: toDate });
    
    this.setState({
      
      om_selectedRecords:[],
      selectAllReqId:''
    })
    
    //
  }

  public om_searchSpace = (e) => {
    //debugger;
    const keyword = e.target.value;
    this.setState({ om_searchText: keyword });
    //debugger;
    if (keyword === "") {
      this.setState({ om_myModels: this.state.om_allData });
      this.tableDataShow();
    } else {
      let result = this.state.om_allData;
      //result = result.filter(element => element.Filename.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Customer.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Milestone.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Primary_Skill.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Project.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Ref.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Sequence.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Task.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Work_Order.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.Zone.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.project_name.trim().toUpperCase().startsWith(keyword.toUpperCase()) || element.status.trim().toUpperCase().startsWith(keyword.toUpperCase()));
     
      
     
        result = result.filter(element => element.RequestDetailsID.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||
      
      element.Mail_Relevance.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||   
      element.MultipleOrdersFlag.trim().toUpperCase().startsWith(keyword.toUpperCase()) ||    
      element.Plant.trim().toUpperCase().startsWith(keyword.toUpperCase()) );
      
      
      this.setState({ om_myModels: result })

    }
  }
  private getType = (event) => {
   // console.log(event)
  //  let result = this.state.om_allData;

    if (event != null) {
    //  result = result.filter(element => element.project_name == event.value);
     // this.setState({ om_myModels: result })
      this.setState({ appliedFilters: event });
    } else {
     // this.setState({ om_myModels: result })
      this.setState({ appliedFilters: [] });
    }
  }
  
  private om_getCountry = (event) => {
   // console.log(event)
    let result = this.state.om_allData;

    if (event != null) {
     // result = result.filter(element => element.Country == event.value);
     // this.setState({ myModels: result })
      this.setState({ om_selectedCountry: event });
      this.setState({ om_af_Country: event.value });
      
      
    } else {
      //this.setState({ myModels: result })
      this.setState({ om_selectedCountry: [] });
      this.setState({ om_af_Country: "" });
    }
  }
  
  
  private om_getStatus = (event) => {
   // console.log(event)
  //  let result = this.state.allData;

    if (event != null) {
     // result = result.filter(element => element.Status == event.value);
     // this.setState({ myModels: result })
      this.setState({ om_selectedStatus: event });
      this.setState({ om_af_Status: event.value});
      
      
    } else {
    // this.setState({ myModels: result })
      this.setState({ om_selectedStatus: [] });
      this.setState({ om_af_Status: "" });
    }
  }


  public handleShow = async (model) => {
   // console.log(model)

    this.setState({ show: true, selectedRow: model })
  }
/*
  green(){
    this.green_selected=!this.green_selected;
  this.yellow_selected=false;
  this.red_selected=false;
    if(this.green_selected){
      const result = this.state.om_allData;
      this.setState({
       myModels: []
      });
    }else{
      this.setState({
        myModels: this.state.allData
    })}
  }
  yellow(){ 
    this.green_selected=false;
    this.yellow_selected=!this.yellow_selected;
    this.red_selected=false;
    if(this.yellow_selected){
      const result = this.state.allData;
      this.setState({
       myModels: result
      });
    }else{
      this.setState({
        myModels: this.state.allData
    })}

   

  }
  red(){
    this.green_selected=false;
    this.yellow_selected=false;
    this.red_selected=!this.red_selected;
    if(this.red_selected){
    this.setState({
      myModels: []
     });}else{
      this.setState({
        myModels: this.state.allData
    })
     }
   
    

  }
*/
  
  private fromDateChange = (event) => {
    this.setState({ fromDate: event.target.value })
    if (this.state.toDate != '') {
      var startDate = new Date(event.target.value);
      var endDate = new Date(this.state.toDate);
     // console.log(event.target.value)
     // console.log(startDate)
     // console.log(endDate)
    /*  var resultProductData = this.state.allData.filter(a => {
        let date1 = a.Timestamp.split(" ")[0]
        console.log(date1)
        var date = new Date(date1);
        console.log(date)
        return (date >= startDate && date <= endDate);
      });
      this.setState({ myModels: resultProductData })
      console.log(resultProductData)*/
    }
  }

  private toDateChange = (event) => {
    this.setState({ toDate: event.target.value })
    if (this.state.fromDate != '') {
     // console.log(this.state.fromDate,"this.state.fromDate")
      var startDate = new Date(this.state.fromDate);
      var endDate = new Date(event.target.value);
     // console.log(event.target.value);
     // console.log(startDate);
     // console.log(endDate);
     /* var resultProductData = this.state.allData.filter(a => {
        console.log(a.Timestamp,"timeStamp")
        let date1 = a.Timestamp.split(" ")[0]
        console.log(date1)
        var date = new Date(date1);
        console.log(date)
        return (date >= startDate && date <= endDate);
      });
      this.setState({ myModels: resultProductData })
      console.log(resultProductData)*/
    } else {
      alert("Please select from date")
    }
  }

  public TF_CustEmailDateNew(){
    const { SortDate } = this.state;

    let result = this.state.om_myModels;
    if (SortDate === "ASC") {
      result.sort((a, b) => {
        if (isNaN(new Date(b["Email_Date"]).getTime())&&isNaN(new Date(a["Email_Date"]).getTime())) { 
          return (b["Email_Date"]!=""?(moment(b["Email_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0)
          - (a["Email_Date"]!=""?(moment(a["Email_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0);
        }
        else{
          return (a["Email_Date"]!=""?(new Date(a["Email_Date"]).getTime()):0)
          - (b["Email_Date"]!=""?(new Date(b["Email_Date"]).getTime()):0);
        }
      });
      this.setState({
        om_myModels: result,
        SortDate: "DESC"
      })
    }
    else {
      result.sort((a, b) => {
        if (isNaN(new Date(b["Email_Date"]).getTime())&&isNaN(new Date(a["Email_Date"]).getTime())) { 
          return (b["Email_Date"]!=""?(moment(b["Email_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0)
          - (a["Email_Date"]!=""?(moment(a["Email_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0);
        }
        else{
          return (b["Email_Date"]!=""?(new Date(b["Email_Date"]).getTime()):0)
          - (a["Email_Date"]!=""?(new Date(a["Email_Date"]).getTime()):0);
        }
     });
      this.setState({
        om_myModels: result,
        SortDate: "ASC"
      })
    }
  }

  public TF_CustEmailDate()
  {
    //this.setState({af_CEmail:e});
    
    const { SortDate } = this.state;
    
 let result = this.state.om_myModels;

    if(SortDate === "ASC")
    {
    
     let sortConfig = {key:"Email_Date",direction:"ascending"};
     //
     if (sortConfig !== null) {
      result.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
     //
     this.setState({ om_myModels: result });
      this.setState({ SortDate: "DESC" });
    }
    else
    {
      //
      let sortConfig = {key:"Email_Date",direction:"descending"};
      //
      if (sortConfig !== null) {
       result.sort((a, b) => {
         if (a[sortConfig.key] < b[sortConfig.key]) {
           return sortConfig.direction === 'ascending' ? -1 : 1;
         }
         if (a[sortConfig.key] > b[sortConfig.key]) {
           return sortConfig.direction === 'ascending' ? 1 : -1;
         }
         return 0;
       });
     }
      //
      //
      this.setState({ om_myModels: result });
      this.setState({ SortDate: "ASC" });
    }
    
     
  }
  
  
  public updateStatusAll(){
    let p = [...this.state.om_myModels]
      Object.keys(p).map(key=>{
        if(p[key]["RequestDetailsID"] == this.state.checkedId){
          this.handleSingleCheck_OM_New(p[key],true,'')
          p[key]["isChecked"] = true
        }
      })
      this.setState({ om_myModels:p,hidePopUp:true })
  }

  public tableDataShow = () => {
    const { om_myModels,currentPage, displayCountPerPage,currentLength} = this.state;
    
    const indexOfLastRec = currentPage * displayCountPerPage;
    const indexOfFirstRec = indexOfLastRec - displayCountPerPage;
    const myModelsNew = om_myModels.slice(indexOfFirstRec, indexOfLastRec);
     // Logic for displaying page numbers
     // new logic start 05-Mar-2022
     let isCheckBox = false , isSelectAll = true
     if(om_myModels.length>0){
      isCheckBox =  om_myModels.every( (val, i, arr) => val["RequestDetailsID"] === arr[0]["RequestDetailsID"] )
     }
     debugger;
     Object.keys(om_myModels).map(key=>{
      if(om_myModels[key]["isChecked"]!=true){
        isSelectAll = false
      }
    })
    let id = ""
      if(isCheckBox){
        id = om_myModels[0]["RequestDetailsID"]
      }
      const dark: ICustomizations = {
        settings: {
          theme: getDarkTheme(),
        },
        scopedSettings: {},
    };
     // new logic end 05-Mar-2022.
     
 

     
    
    return (
      <div   >
     {/*    
      <Customizer {...dark}>
        <Dialog
                        onDismiss={()=>{this.setState({hidePopUp:true})}}
                        hidden={this.state.hidePopUp}
                        dialogContentProps={{
                            type: DialogType.normal,
                            title: "There are other records with this request id, do you want to update them as well?"
                        }}
                        >
                        <DialogFooter>
                            <PrimaryButton
                                onClick={()=>this.updateStatusAll()}
                                text={"Yes"}/>
                                <PrimaryButton
                                onClick={()=>{this.setState({hidePopUp:true})}}
                                text={"No"}/>
                        </DialogFooter>
                  </Dialog>
        </Customizer> 
        
        <Modal isOpen={!this.state.hideSuccPopUp} centered={true}   >
             
              <ModalBody style={{backgroundColor:'black'}}>
                  <label ><h5><p style={{color:'white'}}> Clear Exception before selecting 'Success' status!</p></h5> </label>
              </ModalBody>
              <ModalFooter style={{backgroundColor:'black'}}>
                  
                  <button
                  className="btn-custom btn-xl mr-2 float-right"  style={{width:"80px"}}
                 
                      onClick={()=>{this.setState({hideSuccPopUp:true})}}
                     >
                      OK
                  </button>
                 
              </ModalFooter>
          </Modal>
           */}   
        <div className="card wrap-body-my_models shadow model-data mt-2 filterGrid">
          <table className="table table-dark table-striped" style={{ fontSize: '12px' }}>
            <thead>
              <tr>
              
              <th style={{ width: '50px' }}>
              {isCheckBox?<input type="checkbox" checked={isSelectAll} onClick={(e)=>this.handleClickNew_OM(e,id)} />:null}
                 {/*
               <input type="checkbox" onClick={this.handleClick.bind(this)} />
                 */ }
               </th>
               {/*
			  <th style={{ width: '50px' }}><input type="checkbox" onClick={this.handleClick.bind(this)} /></th>
               */} 
			    <th style={{ width: "500px", tableLayout: "fixed" }} >Batch</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Company Name</th>
                <th style={{ width: "1000px", tableLayout: "fixed" }}>Request Details ID</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Mail Relevance</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Delivery Date</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Order Quantity</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>PO</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Plant</th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Status
                
                <button  
                
                style={{ background: '#222830',  color: 'lightgray', border:'none' 
                         }}
                                                    onClick={() => this.om_TF_Status()}>
                                                       <i className="fas fa-angle-down" style={{ }}></i>
                                               
                                                </button>
                                                {this.state.om_displayStatusdd?
                                                  <div>
                                                    <Select options={this.state.om_spl_statusList}
                          value={this.state.om_selectedTFStatus}
                          onChange={this.om_getTFStatus}
                          className="react-select-container z-index-19"
                          isClearable={false}
                          placeholder="Status"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}
/>
                                                  </div>  
                                              :
                                              <div>
                                                </div>  
                                              }
                </th>
                
                
                <th style={{ width: "500px", tableLayout: "fixed" }}> Country
                <button                 
                style={{ background: '#222830',  color: 'lightgray', border:'none' 
                         }}
                                                    onClick={() => this.om_TF_Country()}>
                                                      
                                                       <i className="fas fa-angle-down" style={{ }}></i>
                                               
                                                </button>
                                                {this.state.om_displayCountrydd?
                                                 <div>
                                                     <Select options={this.state.om_Country}
                          value={this.state.om_selectedTFCountry}
                          onChange={this.om_getTFCountry}
                          className="react-select-container z-index-19"
                          isClearable={false}
                          placeholder="Country"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}

                        />
                                                    
                                                  </div>:
                                                  <div></div>
                                                }
                                                </th>
               <th style={{ width: "500px", tableLayout: "fixed" }}>Email Sent Date
                <button  
                
                style={{ background: '#222830',  color: 'lightgray', border:'none' 
                         }}    onClick={() => this.TF_CustEmailDate()}
                                                   >
                                                       <i className="fas fa-angle-down" style={{ }}></i>
                                               
                                                </button>
                </th>
                <th style={{ width: "500px", tableLayout: "fixed" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {om_myModels && om_myModels.map((model, index) => {
                  return index <= currentLength ? (
                    <tr key={index}>
                    
                    <td>
                  
                  {/*   <input type="checkbox" onClick={(e) => this.om_handleSingleCheck(model,e)}  />*/}
                    <input type="checkbox" checked={model["isChecked"]} onClick={(e) => {this.validateMultiple_OM(model,e,index)}}   />
                  
                    </td>
					  {/* 
                    <td><input type="checkbox" onClick={() => this.handleSingleCheck(model)}  /></td>
                    */}
					<td>{model.Batch}</td>
                    <td>
                      {model.CompanyName}
                    </td>
                    <td>
                      {model.RequestDetailsID}
                    </td>
                    <td>
                      {model.Mail_Relevance}
                    </td>
                    <td>
                      {model.DeliveryDate}
                    </td>
                    <td>
                      {model.OrderQuantity}
                    </td>
                    <td>
                      {model.PO}
                      
                    </td>
                    <td>
                      {model.Plant}
                      
                    </td>
					<td>
                      {model.Status}
                      
                    </td>
                    <td>
                      {model.Country}
                      
                    </td>
                    <td >{model.Email_Date}
                    </td>
                    <td className="action-control">
                     
                      <button role="button" className="view"
                        onClick={() => this.goToModel(model)}>
                        <i className="fa fa-edit bg-color-1" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                  ):null
              })}
            </tbody>
          </table>
          {this.state.currentLength<=om_myModels.length?(
                      <div className="click-here-css" 
                      onClick={()=>{this.setState({currentLength:this.state.currentLength+20})}}>Show more</div>
          ):null}
           {/* <span className="show-results-css">Remaining records:{this.state.om_myModels.length - this.state.currentLength > 0 ? this.state.om_myModels.length - this.state.currentLength : 0}</span> */}
         <span className="show-results-css" >Showing results &nbsp;
           {this.state.currentLength > this.state.om_myModels.length?this.state.om_myModels.length:this.state.currentLength} out of {this.state.om_myModels.length}</span>
        </div>
      
      </div>
    );
  }


  public render() {

    //
    const { om_myModels,currentPage, displayCountPerPage,om_Country,om_statusList,om_updatestatusSelVal,om_selectedRecords} = this.state;
     //console.log("no of models- ord mgmt==>"+om_myModels.length);
     // Logic for displaying page numbers
     //console.log("first model==>"+JSON.stringify(om_myModels[0]));
     const pageNumbers = [];
     for (let i = 1; i <= Math.ceil(om_myModels.length / displayCountPerPage); i++) {
       pageNumbers.push(i);
     }
     
     const om_changedmstatusOptions = [
      { value: 'Success', label: 'Success' },
      { value: 'Completed', label: 'Completed' },
      { value: 'Exception', label: 'Exception' },
      { value: 'Not Started', label: 'Not Started' }
     
  ];
     
     const lastpage = Math.ceil(om_myModels.length / displayCountPerPage);
 
     let numeval =Math.trunc ((currentPage+displayCountPerPage-1)/displayCountPerPage);
     let ePage  =  numeval*displayCountPerPage;
     if(ePage>lastpage)
     {
      ePage=lastpage;
     }
     const sPage =  ePage-10+1;
     const renderPageNumbers = pageNumbers.map(number => {       
      let classes = currentPage === number ? "pageactive" : '';   
         
      if ((number <= ePage)&&(number >= sPage)) {        
       return (
         <li
           key={number}           
           className={classes}           
           id={number}
           onClick={(e)=>this.handlePageClick(e)}  >
           {number}
         </li>
       );
     }
    });
     
    //
    return (
      <>
        <HeaderComponent
          history={this.props.history}
          match={this.props.match}
          location={this.props.location} />
        <LoadingOverlay
          active={this.state.om_loadingProjects}
          spinner
          className={this.state.om_loadingProjects ? "wrap-queue-height" : ""}
          text={this.state.om_loaderText}
        >

          {this.state.om_loadModal ? <Spinner
            size={SpinnerSize.large}
            label={this.state.om_loaderText}
            ariaLive="off"
            className="mt-5"
            labelPosition="bottom"
          /> :
            <div className="container-fluid animated fadeIn">
              {this.state.om_loadProcess ? <Spinner
                size={SpinnerSize.large}
                label={this.state.om_loaderText}
                ariaLive="off"
                className="mt-5"
                labelPosition="bottom"
              /> : 
              <>
              
              <div className="row mt-2" id="accordionDM">
<div className="col-md-6" style={{ marginTop: '4px' }}>
  </div>
  
<div className="col-md-4" style={{ marginTop: '10px' }}>
                        <div style={{ display: 'flex' }}>
                          <input type="text" placeholder="search" value={this.state.om_searchText} 
                          onChange={(e) => this.om_searchSpace(e)} 
                          style={{ background: '#222830', border: '1px solid #222830', color: 'lightgray', 
                          width: '100%', borderRadius: '3px', padding: '5px' }} /> 
                           <i className="fas fa-search" style={{ marginLeft: '-5%', marginTop: '10px' }}></i>

                        </div>
                      </div>
                                       
                  
  <div className="col-md-2" style={{ marginTop: '4px' }}>

                    <button className="btn-custom float-right" onClick={() => this.om_updateModels(true)} 
                    style={{ marginRight: '1%', fontWeight: 'bold', borderRadius: '5px' }}>
                      <i className="fas fa-sync-alt"></i> Refresh  </button>
                   
                        <button className="btn-custom float-right" 
                        
                                               onClick={() => this.outClick()} 
                                               style={{ marginRight: '1%', fontWeight: 'bold', borderRadius: '5px' }}>
                      Advanced Filters   </button> 
                       
                                                     
                      
                      
                      
                      
                      
                  {/* <button className="btn-custom float-right" onClick={() => this.updateModels(true)} style={{ marginRight: '1%', fontWeight: 'bold', borderRadius: '5px' }}>
                      Process  </button> */} 
                  </div>



                </div>
              <div className="row mt-2">
                
                
                
                {/*  

<div className="col-md-12" style={{ marginTop: '1px' }}>
                        <div style={{ display: 'flex' }}>
                          <input type="text" placeholder="search" onChange={(e) => this.searchSpace(e)} style={{ background: '#222830', border: '1px solid #222830', color: 'lightgray', width: '100%', borderRadius: '3px', padding: '5px' }} />  <i className="fas fa-search" style={{ marginLeft: '-2%', marginTop: '10px' }}></i>

                        </div>
                      </div>
                  <div className="col-md-10">
                    <div className="input-group input-group-sm my-model-filter ">
                      
                      <div className="col-md-4">
                      <div>
                        Order  Date:
                          </div>

                        <div style={{ display: 'inline-flex' }}>
                          <div>
                            <input type="date" placeholder="From Date" style={{ background: '#222830', border: '1px solid #222830', color: 'lightgray', padding: '17px', borderRadius: '4px' }}

                              maxLength={20} minLength={4} onChange={(e) => this.fromDateChange(e)} name="createModel" />
                          </div> &nbsp; &nbsp;
                        <div style={{ display: 'inline-flex' }}>
                            <input type="date" placeholder=" To Date " style={{ background: '#222830', border: '1px solid #222830', color: 'lightgray', padding: '17px', borderRadius: '4px' }}
                              maxLength={20} minLength={4} onChange={(e) => this.toDateChange(e)} name="createModel" />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-2">
                      <div style={{color: 'lightgray'}}>
                       Status
                        </div>
						<Select options={this.state.statusList}
                          value={this.state.selectedStatus}
                          onChange={this.getStatus}
                          className="react-select-container z-index-19"
                          isClearable={false}
                          placeholder="Status"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}

                        />
                          
                        </div>


<div className="col-md-2">
                      <div style={{color: 'lightgray'}}>
                       Country
                        </div>
                       
                        <Select options={this.state.country}
                          value={this.state.selectedcountry}
                          onChange={this.getCountry}
                          className="react-select-container z-index-19"
                          isClearable={false}
                          placeholder="Country"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}

                        />
                          </div>
						  
						  
						  		  
<div className="col-md-2">
<div style={{color: 'lightgray'}}>
                      
                        </div>
                      <div style={{ marginTop: '15px' }} >
					  <button className="btn-custom float-right" onClick={() => this.searchOrders()} style={{ marginRight: '1%', fontWeight: 'bold', borderRadius: '5px' }}>
                      <i className="fas fa-sync-alt"></i> Search  </button>
                        </div>
						</div>
						
										  		  
<div className="col-md-2">
<div style={{color: 'lightgray'}}>
                      
                        </div>
                      <div style={{ marginTop: '15px' }} >
					  <button className="btn-custom float-right" onClick={() => this.refreshOrders()} style={{ marginRight: '1%', fontWeight: 'bold', borderRadius: '5px' }}>
                      <i className="fas fa-sync-alt"></i> Refresh  </button>
                        </div>
						</div>
						  
						  

                    </div>

                  </div>
				  
		
                  <div className="col-md-2" style={{ marginTop: '4px' }}>

                  </div>

                */}

                </div>
                
                
                
                
                
                <div className="row mt-2" id="accordionDM1">
                <div className="col-md-8" style={{ marginTop: '4px' }}>
                  </div>
                <div className="col-md-4" style={{ marginTop: '4px' }}>
  {om_selectedRecords&&om_selectedRecords.length>0?
  <div className="row">
     <div className="col-md-8">
  <Select options={om_changedmstatusOptions}
  value={om_updatestatusSelVal}                                          
  onChange={e => this.om_SelectRecordStatus(e)}
  className="react-select-container z-index-19"
  isClearable={true}
  theme={(theme) => ({
      ...theme,
      colors: {
          ...theme.colors,
          primary25: "#161a1f",
          primary: "#6b727d",
          neutral0: "#222830",
          neutral20: "#44474c",
          neutral30: "#272c33",
          neutral50: "#fff",
          neutral80: "#9da7b5",
      },
  })}

/>
</div>
<div className="col-md-4">
  <button className={om_updatestatusSelVal!=null&&om_updatestatusSelVal["value"]?"btn-custom float-right":"btn-custom css-status float-right"} 
                        
                        onClick={() => this.om_UpdateRecordStatus()}
                        disabled={om_updatestatusSelVal!=null&&om_updatestatusSelVal["value"]?false:true}
                        style={{ marginRight: '1%', fontWeight: 'bold', borderRadius: '5px' }}>
                    Update Status   </button>
                    </div>
</div>:
<div>
  </div> 
  }
  
  
  
  </div>
                  </div>
                
                </>
                }
             
              {this.tableDataShow()}
            
            {/* <div className="row mt-2">
                <div className="col-10 ">
                  </div>
                  <div className="col-2 ">
                  <ul id="page-numbers">
                 <li>
                 <span 
                 
                 onClick={(e)=>this.handlePreviousClick(e)}  
                >&laquo;</span>
                 </li>
         {renderPageNumbers}
         <li>
         <span 
          onClick={(e)=>this.handleNextClick(e)}
         >&raquo;</span> </li>
                 
            
           </ul>
                  </div>
                </div>
                <div className="row ">
                <div className="col-8 ">
                  </div>
                  <div className="col-4 ">
                  <ul id="page-numbers">
                 
                 Displaying Page <span className="fcolor">&nbsp; {currentPage}&nbsp;</span> of  <span className="fcolor">&nbsp;{lastpage}&nbsp; </span>pages
            
           </ul>
                  </div>
                </div>
              
              
             */}
              <div>
             
              </div>

            </div>
          }
          
          
          
              
                      
{this.state.om_displayAdvancedPopup &&
                    <div className="doc_mgt_add_filters_model_add " >
                      
                        <LoadingOverlay
                            active={false}
                            spinner
                            text="Creating Validation">
                            <div className="row " 
                            style={{ marginRight:"2%",marginTop:"-3%", float:"right"}}>

                                <div className="col-md-9 offset-md-3">
                                <div ref={node => { this.orderRef = node; }}>
                                    <div className="card shadow bgWhite1" >

                                        <div className="card-header bgWhite1">
                                            <div className="text-center">
                                                <h5>Add Filters</h5>

                                            </div>
                                        </div>

                                        <div className="card-body bgWhite1 adpopscr"  >

                                            <div className="row">

                                                <div className="col-md-6" >
                                                    <label >PO Number:</label>
                                                    <input type="text" className="form-control" id="af_PO" 
                                                    name="endpoint_name" value={this.state.om_af_PO}
                                                      
                                                        onChange= {e => this.om_changeField_PO(e.target.value)}
                                                        />
                                             
                                             
                                                </div>

                                                <div className="col-md-6" >
                                                    <label>Mail_Relavance:</label>
                                                    <input type="text" className="form-control" id="af_Order" name="endpoint"
                                                    value={this.state.om_af_mail_relavance}
                                                         
                                                        onChange= {e => this.om_changeField_Order(e.target.value)}
                                                        />                                                    
                                                </div> 
                                                <div className="col-md-6" >
                                                    <label>MultipleOrdersFlag:</label>
                                                    <input type="text" className="form-control" id="af_SO" name="endpoint"
                                                    value={this.state.om_af_MultipleOrdersFlag}
                                                         
                                                        onChange= {e => this.om_changeField_SO(e.target.value)}
                                                        />                                                    
                                                </div> 
                                                {/* 
                  <div className="col-md-6" >
                                                    <label>Ship To:</label>
                                                    <input type="text" className="form-control" id="af_Ship" 
                                                    value={this.state.om_af_Ship}
                                                    name="endpoint_name"                                                        
                                                        onChange= {e => this.om_changeField_Ship(e.target.value)}
                                                        />                                            
                                                    
                                                </div>
                                                */}
                                                
                                                
                                                <div className="col-md-6" >

                                                    <label>Plant:</label>
                                                    <input type="text" className="form-control" id="af_Plant" 
                                                     value={this.state.om_af_Plant}
                                                    name="endpoint_name"
                                                    
                                                    onChange= {e => this.om_changeField_Plant(e.target.value)}
                                                      />
                                             

                                                </div>

                                                <div className="col-md-6" >
                                                <label> From Date:</label>
                                                <input type="date"
                                                
                                                id="af_FromDate"
                             value={this.state.om_af_FromDate}
                             className="form-control"
                            placeholder="From Date"
                            

                              maxLength={20} minLength={4} 
                              onChange={(e) => this.om_changeField_FromDate(e.target.value)} name="createModel" />
                          </div>
                                                
                                                
                                                    
                                             
                                               
                                                
                                                <div className="col-md-6" >
                                                <label> To Date:</label>
                                                <input type="date"
                                                 className="form-control"
                                                id="af_ToDate"
                             value={this.state.om_af_ToDate}
                            
                            placeholder="From Date"
                         
                              maxLength={20} minLength={4} 
                              onChange={(e) => this.om_changeField_ToDate(e.target.value)} name="createModel" />
                              
                                                
                                                
                                             
                                                </div>
                                                
                                                <div className="col-md-6" >
                                                <label> Country:</label>
                                                
                                                <Select options={this.state.om_Country}
                                                ref={node => { this.nodeCountryDropdown = node; }}
                                                menuPortalTarget={document.body} 
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                          value={this.state.om_selectedCountry}
                          onChange={this.om_getCountry}
                          className="react-select-container z-index-19"
                          isClearable={false}
                          placeholder="Country"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}

                        />
                        
                        
                                               
                                             
                                                </div>
                                                
                                                <div className="col-md-6" >
                                                <label> Status:</label>
                                                
                                                <Select options={this.state.om_statusList}
                                                menuPortalTarget={document.body} 
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                 ref={node => { this.nodeDropdown = node; }}
                          value={this.state.om_selectedStatus}
                          onChange={this.om_getStatus}
                          className="react-select-container z-index-19"
                          isClearable={false}
                          placeholder="Status"
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#161a1f",
                              primary: "#6b727d",
                              neutral0: "#222830",
                              neutral20: "#44474c",
                              neutral30: "#272c33",
                              neutral50: "#fff",
                              neutral80: "#9da7b5",
                            },
                          })}
/>
                                                
                                                </div>
                                                
                                                
                                                
                                               
                  <div className="col-md-6" >
                                                    <label>RequestDetailsID:</label>
                                                    <input type="text" className="form-control" id="af_CEmail" 
                                                    value={this.state.om_af_RequestDetailsID}
                                                    name="endpoint_name"                                                        
                                                        onChange= {e => this.om_changeField_CEmail(e.target.value)}
                                                        />                                            
                                                    
                                                </div>
                                                

                                            </div>

                                        </div>

                                    </div>

                                    <div className="card-footer text-right bgWhite1">
                                        <button type="submit"
                                         
                                          className="btn btn-sm mr-2"  onClick={() => this.om_ApplyAdvancedFilters()}>Apply Filters</button>
                                      
                                      <button type="submit"
                                         
                                         className="btn btn-sm mr-2"  onClick={() => this.om_ClearAdvancedFilters()}>Clear Filters</button>
                                     
                                        <button type="button"
                                            className="btn btn-sm "  onClick={() => this.outClick()} >Cancel</button>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </LoadingOverlay>
                    </div>
                }
                    


        </LoadingOverlay>
      </>
    );
  }

  /**
   * Get Queue Data
   */
  public goToModel = async (model) => {
    //debugger; 
    await this.setState({ loadingProjects: true});
   // toast.success("Fetching Order Details!", { position: toast.POSITION.TOP_CENTER });
   // console.log("RequestDetailsID==>"+model.RequestDetailsID);   
    /* 
    //new code start
    const endpointURL = getOrderMgtdocUrlsEndpoint(model.RequestDetailsID);
    axios( endpointURL , { method: "GET" ,  headers}).
    then((resp) => {
       this.setState({ loadingProjects: false });
      if (resp.status === 200 || resp.status === 201) {
       debugger; 
        model.Attachment_SAS_Url= resp.data.Attachment_SAS_Url?resp.data.Attachment_SAS_Url:"";
        model.Body_SAS_Url= resp.data.Body_SAS_Url?resp.data.Body_SAS_Url:"";       
        
        localStorage.setItem("Customer", model.Customer);
    localStorage.setItem("fileName", model.Filename);
    localStorage.setItem("selectedDocument", JSON.stringify(model));
    
    this.props.history.push(`/editTagsData_for_OrderDocument`);
        //this.setState({tagsShow:true})
       // toast.success("Tags updated Sucessfully", { position: toast.POSITION.TOP_CENTER });
      }
      else
      {
         this.setState({ loadingProjects: false });
        toast.error("Error in fetching the Order Details!", { position: toast.POSITION.TOP_CENTER });
      }
    });
    
    //new code end
    */
    //make a call get the urls
  
    localStorage.setItem("Customer", model.Customer);
    localStorage.setItem("fileName", model.Filename);
    
    //
    let selectedFilters={      
      om_searchText:this.state.om_searchText,
      om_af_Status:this.state.om_af_Status,
      om_af_Country:this.state.om_af_Country,
      om_af_FromDate:this.state.om_af_FromDate,
      om_af_ToDate:this.state.om_af_ToDate,      
      om_af_mail_relavance:this.state.om_af_mail_relavance,
      om_af_PO:this.state.om_af_PO,
      om_af_Plant:this.state.om_af_Plant,    
      af_MultipleOrdersFlag:this.state.om_af_MultipleOrdersFlag, 
      af_RequestDetailsID:this.state.om_af_RequestDetailsID,       
      om_displayCountrydd:this.state.om_displayCountrydd,
      om_displayStatusdd:this.state.om_displayStatusdd,   
      om_selectedTFStatus:this.state.om_selectedTFStatus,
      om_selectedTFCountry:this.state.om_selectedTFCountry,
      om_af_MultipleOrdersFlag:this.state.om_af_MultipleOrdersFlag,
      om_af_RequestDetailsID:this.state.om_af_RequestDetailsID
    };
    
    
    localStorage.setItem("omDocMgtBack", "N");
    //
    localStorage.setItem("selectedomDocMgtFilters", JSON.stringify(selectedFilters));
    localStorage.setItem("selectedomDocument", JSON.stringify(model));
    this.props.history.push(`/editTagsData_for_OrderDocument`);
    
  }
   


  /**
  * get updated models
  */
  private updateModels = async (flag?: boolean) => {
    this.records = [];
    this.setState({ om_loadModal: true, selectedFilter: '', om_loaderText: 'Loading files to preview', appliedFilters: '' });
    const modelData = await this.props.userOperationsActions.documentMangement();
    this.setState({ om_loadModal: false, om_myModels: modelData, om_allData: modelData });
  }
   
  
  public searchOrders = async () => {
     	
	//debugger;
	//get start date
	let stDate = this.state.fromDate ;
	//get end date
	let endDate= this.state.toDate ;
	//get country
	let country = this.state.selectedcountry ;	 
	//get status	
	let selStatus = this.state.selectedStatus;	
	let resData = this.state.om_allData;
	/*
	if (selStatus.value) {
		resData = resData.filter(element => element.Status == selStatus.value);
	}	
	if (country.value) {
		resData = resData.filter(element => element.Country == country.value);
	}	
  */
	if(stDate != '' && endDate != '')
	{		
		let startDate = new Date(stDate);
		let endingDate = new Date(endDate);
		
    if(startDate <= endingDate)
    {
   //   this.getInitialDatawithFilters(stDate,endDate);
     // resData = this.state.allData
    }
    else
    {
      toast.warn("From date should be less than To date", { position: toast.POSITION.TOP_CENTER });
    }
	/*	resData = this.state.allData.filter(a => {		 
			let date1 = a.Timestamp.split(" ")[0];		 
			var date = new Date(date1);		 
			return (date >= startDate && date <= endingDate);
		  });
      */
	}	
     // this.setState({ myModels: resData });	
  }
  
  /*
  
  public async getInitialDatawithFilters(fromdate:string, todate:string)
  {
	  debugger;
    await this.setState({ loadingProjects: true});
    toast.success("Fetching the Records", { position: toast.POSITION.TOP_CENTER });
	const modelData = await this.props.userOperationsActions.orderMangementByDate(fromdate, todate);
    let firstRow = modelData[0];
    this.allDettsils = modelData;
    let keys = [];
    let finalKeys = [];
    
    toast.success("Number of Records Found:"+this.allDettsils.length, { position: toast.POSITION.TOP_CENTER });
    if (this.allDettsils.length) {
      keys = Object.keys(firstRow);
      keys.forEach((element, i) => {
        if (element == 'Tagsinfo' || element == 'url') {
          keys.splice(i, 1)
        }
      })
    }

    console.log(keys)
    let Aimodels = []
    this.allDettsils.forEach(element => {
      if (Aimodels.length > 0) {
        let present = false;
        Aimodels.forEach(data => {
          if (data.value == element.PartitionKey) {
            present = true;
          }
        })
        if (!present) {
          Aimodels.push({ value: element.PartitionKey, label: element.PartitionKey })
        }
      } else {
        Aimodels.push({ value: element.PartitionKey, label: element.PartitionKey })
      }
    });
    // contry
    let country=[];
    
    //
    this.allDettsils.forEach(element => {
      if (country.length > 0) {
        let present = false;
        country.forEach(data => {
          if (data.value == element.Country) {
            present = true;
          }
        })
        if (!present) {
          country.push({ value: element.Country, label: element.Country })
        }
      } else {
        country.push({ value: element.Country, label: element.Country })
      }
    });
    //
	
	let statusList=[];
	//
	this.allDettsils.forEach(element => {
		if (statusList.length > 0) {
		  let present = false;
		  statusList.forEach(data => {
			if (data.value == element.Status) {
			  present = true;
			}
		  });
		  if (!present) {
			statusList.push({ value: element.Status, label: element.Status })
		  }
		} else {
			statusList.push({ value: element.Status, label: element.Status })
		}
	  });
	//
  await this.setState({ loadingProjects: false});
    this.setState({ om_loadModal: false, om_myModels: modelData, om_allData: modelData, om_headers: keys, om_AI_models: Aimodels,om_country: country,om_statusList:statusList});

  }
  
  */
  
  public refreshOrders = async () => {
	
	//this.props.history.push(`/orderManagement`);
	/*
	debugger;
	this.setState({
		
	fromDate: '',
    toDate: '',
	selectedcountry:[],
 
	selectedStatus:[]
  });      
	 
  this.getInitialData();*/
  window.location.reload();
  
  }
  
  private om_updateModels = async (flag?: boolean) => {
   
      
      window.location.reload();
      
    }
  
  
  public om_showAdvancedFiltersPopup= async()=>
  {
  
    const { om_displayAdvancedPopup } = this.state;
    this.setState({ om_displayAdvancedPopup: !om_displayAdvancedPopup });
    
  }
  
   
  
  
  public om_changeField_PO(e)
  {
    
   // const { displayAdvancedPopup } = this.state;
  // this.changeField(e.key,e.value);
   this.setState({om_af_PO:e});
  }
  
  
  
  public om_changeField_Order(e)
  {
    this.setState({om_af_mail_relavance:e});
     
  }
  
  
  public om_changeField_Ship(e)
  {
    this.setState({om_af_Ship:e});
   
  }
  
  
  
  public om_changeField_Plant(e)
  {
    this.setState({om_af_Plant:e});
    
  }
  
  public om_changeField_FromDate(e)
  {
    this.setState({om_af_FromDate:e});
    /*
   if(this.state.om_af_ToDate==="")
   {
        
      this.setState({om_af_ToDate:moment().format("YYYY-MM-DD")});
   
   }
   */
    
  }
  
  
  public om_changeField_ToDate(e)
  {
    this.setState({om_af_ToDate:e});
   
  }
  
  
  public om_changeField_SO(e)
  {
    this.setState({om_af_MultipleOrdersFlag:e});
   
  }
 
  
  public om_changeField_CEmail(e)
  {
    this.setState({om_af_RequestDetailsID:e});
   
  }
  
  
  
  public om_CancelAdvancedFilters= async()=>
  {
    this.setState({ om_displayAdvancedPopup: false });
  }
  
      
  
  public om_ClearAdvancedFilters= async()=>
  {
    this.setState({ om_af_Country:"",
    om_af_Status: "",
    om_af_FromDate:"",
    om_af_ToDate: "",
    om_af_mail_relavance: "",
    om_af_PO: "",
    om_af_Plant: "",                         
    om_af_Ship:"",   
    om_af_MultipleOrdersFlag:"", 
    om_af_RequestDetailsID:"",                          
    om_searchText:null,
    
            });  
            
            this.setState({ om_selectedStatus: [] });
            this.setState({ om_selectedCountry: [] });
            
  }
  
  
  
  public om_ApplyAdvancedFilters= async()=>
  {
    this.outClick();
    this.om_getOrderMgtDatabydate_af( );
     
    this.setState({ om_displayAdvancedPopup: false });
  }
  
  
  public om_getOrderMgtDatabydate_af =async ( )=>
  {
    //debugger;
    //
    await this.setState({ om_loadingProjects: true});
    let modelData;
  //  this.setState({ loadModal: true });
   // toast.success("Fetching the Records", { position: toast.POSITION.TOP_CENTER });
    
   //
   let enddate;
   if(this.state.om_af_ToDate==="" && this.state.om_af_FromDate!=="" )
   {
     enddate = moment().format("YYYY-MM-DD");
     this.setState({om_af_ToDate:moment().format("YYYY-MM-DD")});
   }else{
     enddate = this.state.om_af_ToDate;
   }
   //
   
   // console.log("Fetching the Records");
    
    if ((this.state.om_af_FromDate!= "")&&  (enddate!= "")) {
      // moment(fromDate).startOf('day').format("MM/DD/YYYY[T]HH:mm:ss"),moment(toDate).endOf('day').format("MM/DD/YYYY[T]HH:mm:ss")
    //   modelData = await this.props.userOperationsActions.orderMangementByDate(moment(this.state.om_af_FromDate).startOf('day').format("MM/DD/YYYY[T]HH:mm:ss"), moment(enddate).endOf('day').format("MM/DD/YYYY[T]HH:mm:ss"));
    modelData = await this.props.userOperationsActions.orderMangementByDate(moment(this.state.om_af_FromDate).startOf('day').format("YYYY-MM-DD[T]HH:mm:ss"), moment(enddate).endOf('day').format("YYYY-MM-DD[T]HH:mm:ss"));
       //modelData = await this.props.userOperationsActions.documentMangementByDate(this.state.om_af_FromDate,this.state.om_af_ToDate);
    
     this.setState({ om_allData: modelData});
    }
    else
    {
      modelData = this.state.om_allData;
    }
    //debugger;
  //  let firstRow = modelData[0];   
      
    
    if (this.state.om_af_Country!= "" && this.state.om_af_Country!= "All" ) {
      modelData = modelData.filter(element => element.Country.toLowerCase().startsWith(this.state.om_af_Country.toLowerCase()));   
    }     
    if (this.state.om_af_Status!= "" && this.state.om_af_Status!= "All") {
      modelData = modelData.filter(element => element.Status.toLowerCase().startsWith(this.state.om_af_Status.toLowerCase()));   
    } 
    
    if (this.state.om_af_PO!= "") {
      modelData = modelData.filter(element => element.PO.toLowerCase().startsWith(this.state.om_af_PO.toLowerCase()));  
    } 
    
    if (this.state.om_af_Plant!= "") {
      modelData = modelData.filter(element => element.Plant.toLowerCase().startsWith(this.state.om_af_Plant.toLowerCase()));     
    } 
   // if (this.state.om_af_Ship!= "") {
     // modelData = modelData.filter(element => element.ShipTo == this.state.om_af_Ship);    
    //} 
    
    if (this.state.om_af_mail_relavance!= "") {
      modelData = modelData.filter(element => element.Mail_Relevance.toLowerCase().startsWith(this.state.om_af_mail_relavance.toLowerCase()));     
    }  
    
    
    if (this.state.om_af_MultipleOrdersFlag!= "") {
      modelData = modelData.filter(element => element.MultipleOrdersFlag.toLowerCase().startsWith(this.state.om_af_MultipleOrdersFlag.toLowerCase()));    
    }  
    
    
    
    if (this.state.om_af_RequestDetailsID!= "") {
      modelData = modelData.filter(element => element.RequestDetailsID.toLowerCase().startsWith(this.state.om_af_RequestDetailsID.toLowerCase()));     
    }  
    
    //apply column filters -start
    
    
    let coun = this.state.om_selectedTFCountry;
      let counval = coun.value?coun.value:"";     
       
       
      if(counval !== "" && counval !== "All"){     
      modelData = modelData.filter(element => ( element.Country == counval));    
  }
  
  let status = this.state.om_selectedTFStatus;
  let statusval = status.value?status.value:"";
  
    
  if(statusval !== "" && statusval !== "All"){     
    modelData = modelData.filter(element => ( element.Status == statusval));    
}
    
    //apply column filters -end
    
    
    
    
    
    
    
    this.allDettsils = modelData;  
    //console.log("Records count==>"+this.allDettsils.length); 
   // toast.success("Number of Records Found:"+this.allDettsils.length, { position: toast.POSITION.TOP_CENTER });
    //  console.log(keys)
    let Aimodels = [];
    this.allDettsils.forEach(element => {
      if (Aimodels.length > 0) {
        let present = false;
        Aimodels.forEach(data => {
          if (data.value == element.project_name) {
            present = true;
          }
        })
        if (!present) {
          Aimodels.push({ value: element.project_name, label: element.project_name })
        }
      } else {
        Aimodels.push({ value: element.project_name, label: element.project_name })
      }
    });
    // contry
    
     
      
      
    await this.setState({ om_loadingProjects: false});
    modelData.sort((a, b) => {
      if (isNaN(new Date(b["Email_Date"]).getTime())&&isNaN(new Date(a["Email_Date"]).getTime())) { 
        return (b["Email_Date"]!=""?(moment(b["Email_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0)
        - (a["Email_Date"]!=""?(moment(a["Email_Date"], "MM/DD/YYYY HH:mm:ss")["_d"].getTime()):0);
      }
      else{
        return (b["Email_Date"]!=""?(new Date(b["Email_Date"]).getTime()):0)
        - (a["Email_Date"]!=""?(new Date(a["Email_Date"]).getTime()):0);
      }
     });
    this.setState({
      SortDate: "ASC"
    })
    this.setState({ om_myModels: modelData});
   // this.setState({ om_fromDate: fromDate, om_toDate: toDate });
  
  }
  
  
  public om_TF_Status()
  {
        
    const { om_displayStatusdd } = this.state;
    this.setState({ om_displayStatusdd: !om_displayStatusdd });
    this.setState({ om_selectedTFStatus: [] });
  }
  
    
  
  private om_getTFStatus = (event) => {
    //debugger;
   // console.log(event);
    let result = this.state.om_allData;
   
    if (event != null) {
      
      let coun = this.state.om_selectedTFCountry;
      let counval = coun.value?coun.value:"";
      
      if(counval!="")
      {
     result = result.filter(element => ( element.Status == event.value ));
     //result = result.filter(element => ( element.Country == counval ));     
     //     
     if (counval === "All") {
      result = result;
    }
    else
    {
      result = result.filter(element => ( element.Country == counval));
    }
     //
      
      }
      else
      {
        if(event.value==="All")
        {
          result = result ; //.filter(element => ( element.Status == event.value));
        }
        else
        {
          result = result.filter(element => ( element.Status == event.value));
        }
       
      }
      
    //  result = result.filter(element => element.Status == event.value);
      this.setState({ om_myModels: result })
      this.setState({ om_selectedTFStatus: event });
    
      
    } else {
      this.setState({ om_myModels: result })
      this.setState({ om_selectedTFStatus: [] });
     
      
    }
  }
  
  
  public om_TF_Country()
  {
    //this.setState({af_CEmail:e});
    const { om_displayCountrydd } = this.state;
    this.setState({ om_displayCountrydd: !om_displayCountrydd });
    this.setState({ om_selectedTFCountry: [] });
   
  }
  
  
  private om_getTFCountry = (event) => {
    //console.log(event);
    let result = this.state.om_allData;

    if (event != null) {
      
      let status = this.state.om_selectedTFStatus;
      let statusval = status.value?status.value:"";
      if(statusval!="")
      {
        
        if(event.value!="All")
        {
     result = result.filter(element => ( element.Country == event.value ));
        }
        else
        {
          result = result;
        }
         
     
     if (statusval === "All") {
      result = result;
    }
    else
    {
      result = result.filter(element => ( element.Status == statusval )); 
    }
     
    //result = result.filter(element => ( element.Status == statusval )); 
    
    }      else
      {
        
        
        //
        if (event.value === "All") {
          result = result;
        }
        else
        {
          result = result.filter(element => ( element.Country == event.value));
        }
        //
        
       // result = result.filter(element => ( element.Country == event.value));
        
        
        
      }
      
      this.setState({ om_myModels: result });
      this.setState({ om_selectedTFCountry: event });
      
      
    } else {
     this.setState({ om_myModels: result });
      this.setState({ om_selectedTFCountry: [] });
    
    }
  }
  
  
  public om_SelectRecordStatus= async(e)=>
  {
    this.setState({ om_updatestatusSelVal: e });
    this.setState({
      hideSuccPopUp:false});
    
  }
  
  public reloadStatusUpdate = async() => {
    this.setState({
      om_loadModal:true
    })
    let modelData;
    if(this.state.om_af_FromDate!=""){
      
      modelData = await this.props.userOperationsActions.orderMangementByDate
      (moment(this.state.om_af_FromDate).startOf('day').format("YYYY-MM-DD[T]HH:mm:ss"),
      moment(this.state.om_af_ToDate).endOf('day').format("YYYY-MM-DD[T]HH:mm:ss"));
      
    }
    else{
      modelData = await this.props.userOperationsActions.orderMangement();
    }
    
    //
  
      Object.keys(modelData).map(key=>{   
        modelData[key]["isChecked"] = false;
      });
     
    //
    debugger;
    this.om_getOrderMgtDatabydateCountryStatus_af(this.state.om_af_FromDate,this.state.om_af_ToDate,          
             
      this.state.om_af_Country?this.state.om_af_Country:"",
      this.state.om_af_Status?this.state.om_af_Status:"",
         
      this.state.om_af_mail_relavance?this.state.om_af_mail_relavance:"",
      this.state.om_af_PO?this.state.om_af_PO:"",   
      
      this.state.om_af_Country?this.state.om_af_Plant:"",
      this.state.om_af_MultipleOrdersFlag?this.state.om_af_MultipleOrdersFlag:"",   
      this.state.om_af_RequestDetailsID?this.state.om_af_RequestDetailsID:"",
      this.state.om_searchText?this.state.om_searchText:"",
      
      this.state.om_selectedTFStatus,
      this.state.om_selectedTFCountry,
      modelData
      );
      this.setState({
        om_loadModal:false,
        om_selectedRecords:[]
      })
      this.records = []
  }
  
  public om_UpdateRecordStatus_Old= async()=>
  {
    //debugger;
    let selectedstatus = this.state.om_updatestatusSelVal;    
    //make API Call  
    let selRecords=this.state.om_selectedRecords?this.state.om_selectedRecords:[];
    if(selRecords.length>0)
    {
      this.setState({
        om_loadModal:true
      })
      let count = 0 ;
      
     // let reqid =selRecords[0].RequestDetailsID;
      Object.keys(selRecords).map(key=>{
      //  const endpointURL = orderMgt_UpdateStatus(selRecords[key]["RequestDetailsID"],selectedstatus.value,
      //  selRecords[key]["RowKey"]
       // );
       const endpointURL ="";
       const headers = accessToken();
        axios( endpointURL , { method: "GET" ,  headers}).
        then((resp) => {
          if (resp.status === 200 || resp.status === 201) {
            count = count + 1
           // this.setState({tagsShow:true})
           if(count == selRecords.length){
              toast.success("Records updated Sucessfully!", { position: toast.POSITION.TOP_CENTER });
              this.reloadStatusUpdate();
             // window.location.reload();
           }
          }
        });
      })

      // if(reqid.length>2)
      // {
      //    //make API Call start
         
      //    const endpointURL = orderMgt_UpdateStatus(reqid,selectedstatus.value);
      //    axios( endpointURL , { method: "GET" ,  headers}).
      //    then((resp) => {
      //      if (resp.status === 200 || resp.status === 201) {
      //       // this.setState({tagsShow:true})
      //        toast.success("Records updated Sucessfully!", { position: toast.POSITION.TOP_CENTER });
      //        window.location.reload();
      //      }
      //    });
         
         
      //     //make API Call end
         
      // }
    }
    
  }
  
  public om_UpdateRecordStatus= async()=>
  {
    //debugger;
    let selectedstatus = this.state.om_updatestatusSelVal;    
    //make API Call  
    let selRecords=this.state.om_selectedRecords?this.state.om_selectedRecords:[];
    if(selRecords.length>0)
    {
      this.setState({
        om_loadModal:true
      })
      let count = 0 ;
      
      let objectRowKeys =[];
        selRecords.forEach(element=>{
          objectRowKeys.push(element.RowKey);
        })
        
   
        const endpointURL = orderMgt_UpdateStatus(selRecords[0]["RequestDetailsID"],selectedstatus.value);
        const headers = accessToken();
        //debugger;
        axios( endpointURL , { method: "POST" ,  data: {"row_key":objectRowKeys}, headers}).
        then((resp) => {
          if (resp.status === 200 || resp.status === 201) {            
           
              toast.success("Records updated Sucessfully!", { position: toast.POSITION.TOP_CENTER });
              this.reloadStatusUpdate();
              
              this.setState({om_updatestatusSelVal:[]});
              //
              
              //
              
         
          }
        });
     // })

      // if(reqid.length>2)
      // {
      //    //make API Call start
         
      //    const endpointURL = orderMgt_UpdateStatus(reqid,selectedstatus.value);
      //    axios( endpointURL , { method: "GET" ,  headers}).
      //    then((resp) => {
      //      if (resp.status === 200 || resp.status === 201) {
      //       // this.setState({tagsShow:true})
      //        toast.success("Records updated Sucessfully!", { position: toast.POSITION.TOP_CENTER });
      //        window.location.reload();
      //      }
      //    });
         
         
      //     //make API Call end
         
      // }
    }
    
  }
}
